module.exports = __webpack_public_path__ + "img/conference_center.png";